import React from "react";
import { useI18n } from "../lib/i18n";

const sel = "bg-[#191A1F] border border-[#35353B] text-[#F5F3ED] rounded-sm px-3 py-2 outline-none text-sm w-full";
const uniq = (arr) => [...new Set(arr.filter(Boolean))].sort();

export default function ExtraFilters({ filters, setFilters, servers, onApply, onReset }) {
  const { t } = useI18n();
  const scoped = filters.game_id ? servers.filter((s) => s.game_id === filters.game_id) : servers;
  const regions = uniq(scoped.map((s) => s.region));
  const factions = uniq(scoped.map((s) => s.faction));
  const set = (k) => (e) => setFilters({ ...filters, [k]: e.target.value });
  const onKey = (e) => { if (e.key === "Enter") onApply(); };

  return (
    <div className="grid grid-cols-2 md:grid-cols-7 gap-3 md:col-span-5">
      <select data-testid="market-server-filter" value={filters.server_id} onChange={set("server_id")} className={sel}>
        <option value="">{t("market.all_servers")}</option>
        {scoped.map((s) => <option key={s.id} value={s.id}>{s.name}</option>)}
      </select>
      <select data-testid="market-region-filter" value={filters.region} onChange={(e) => setFilters({ ...filters, region: e.target.value, server_id: "" })} className={sel}>
        <option value="">{t("market.all_regions")}</option>
        {regions.map((r) => <option key={r} value={r}>{r}</option>)}
      </select>
      <select data-testid="market-faction-filter" value={filters.faction} onChange={(e) => setFilters({ ...filters, faction: e.target.value, server_id: "" })} className={sel}>
        <option value="">{t("market.all_factions")}</option>
        {factions.map((f) => <option key={f} value={f}>{f}</option>)}
      </select>
      <input data-testid="market-min-price-input" type="number" min="0" placeholder={t("market.min_price")} value={filters.min_price} onChange={set("min_price")} onKeyDown={onKey} className={sel} />
      <input data-testid="market-max-price-input" type="number" min="0" placeholder={t("market.max_price")} value={filters.max_price} onChange={set("max_price")} onKeyDown={onKey} className={sel} />
      <button data-testid="market-apply-filter-btn" onClick={onApply} className="bg-[#D4AF37] text-[#101114] hover:bg-[#F2D98D] transition-colors font-bold rounded-sm px-3 py-2 text-sm">{t("market.apply")}</button>
      <button data-testid="market-reset-filter-btn" onClick={onReset} className="border border-[#35353B] text-[#F5F3ED] hover:border-[#D4AF37] hover:text-[#D4AF37] transition-colors rounded-sm px-3 py-2 text-sm">{t("market.reset")}</button>
    </div>
  );
}
